import { render, staticRenderFns } from "./ProgrammesCard.vue?vue&type=template&id=0beb9a85&"
import script from "./ProgrammesCard.vue?vue&type=script&lang=js&"
export * from "./ProgrammesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports